import Blogs from "./components/Blogs";
import Contact from "./components/Contact";
import Faqs from "./components/Faqs";
import Hero from "./components/Hero";
import Impact from "./components/Impact";
import SolarInstallation from "./components/Installation";
import Projects from "./components/Projects";
import Services from "./components/Services";
import Testimonal from "./components/Testimonal";
import Maintainance from "./components/maintainance";
import Finance from "./components/Finance";
import React from "react";

const Home = () => {
  return (
    <div>
      <section id="hero">
        {" "}
        <Hero />
      </section>
      <section >
        {" "}
        <Maintainance />
      </section>
      <section id="hero">
        {" "}
        <Impact />
      </section>
      <section id="services">
        {" "}
        <Services />
      </section>
      <section id="SolarInstallation">
        <SolarInstallation />
      </section>
      <section >
        {" "}
        <Finance />
      </section>
      <section id="hero">
        {" "}
        <Projects />
      </section>
      <section id="blogs">
        {" "}
        <Blogs />
      </section>
      <section>
        <Testimonal />
      </section>
      <section id="hero">
        {" "}
        <Faqs />
      </section>
      <section id="contact">
        {" "}
        <Contact />
      </section>
    </div>
  );
};

export default Home;
